// useMe — current user, fetched once at boot, refreshable.

import { createContext, useContext } from "react";

export type Role = "admin" | "member";

export interface Me {
  id: number;
  email: string | null;
  name: string | null;
  role: Role;
  allowed_tools: string[] | "all";
  is_setup: boolean;
  disabled: boolean;
  last_login_at: string | null;
}

export const MeContext = createContext<Me | null>(null);
export function useMe(): Me | null { return useContext(MeContext); }
export function useRequireMe(): Me {
  const me = useContext(MeContext);
  if (!me) throw new Error("Not authenticated");
  return me;
}
export function canUseTool(me: Me | null | undefined, tool: string): boolean {
  if (!me || me.disabled) return false;
  if (me.allowed_tools === "all") return true;
  return me.allowed_tools.includes(tool);
}
